<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="12">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :disabled="disabled"
              v-model="dateFormatted"
              :label="getPickerName()"
              hint="MM/DD/YYYY format"
              persistent-hint
              prepend-icon="event"
              @blur="date = parseDate(dateFormatted)"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker :disabled="disabled" v-model="date" no-title @input="menu1 = false"></v-date-picker>
        </v-menu>
        <!-- <p>
          Date in ISO format:
          <strong>{{ date }}</strong>
        </p> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'DatePicker',
  props: {
    pickerData: { date: null, name: 'OrderDate', field: null },
    disabled: null
  },
  data: vm => ({
    date: new Date().toISOString().substr(0, 10),
    dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
    menu1: false,
    menu2: false
  }),

  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date)
    }
  },

  watch: {
    pickerData: {
      immediate: true,
      handler (newVal, oldVal) {
        if (this.pickerData.date) {
          this.date = new Date(this.pickerData.date).toISOString().substr(0, 10)
          this.dateFormatted = this.formatDate(this.date)
          console.log(this.date)
        }
      }
    },
    date (val) {
      this.dateFormatted = this.formatDate(this.date)
      let dateObj = this.pickerData
      dateObj.date = this.date
      this.$emit('clicked', dateObj)
    }
  },

  methods: {
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}/${day}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    getPickerName () {
      console.log('Hello', this.pickerData)
      return this.pickerData.name
    }
  }
}
</script>
